// extracted by mini-css-extract-plugin
export default {"wrap":"vF-z","fullWidth":"wF-z","hideOnDesktop":"xF-z","content":"yF-z","hasOpenedNav":"zF-z","crumbsList":"AF-z","dropdownsWrap":"BF-z"};